export default __webpack_public_path__ + "static/media/milestone-777.183d4db1.png";